export const FASE_CONFIG: Record<string, { label: string; color: string; bg: string }> = {
  scouting:      { label: 'Scouting',      color: '#6366f1', bg: '#eef2ff' },
  acquisizione:  { label: 'Acquisizione',  color: '#f59e0b', bg: '#fffbeb' },
  pratica_usr:   { label: 'Pratica USR',   color: '#3b82f6', bg: '#eff6ff' },
  appalto:       { label: 'Appalto',       color: '#8b5cf6', bg: '#f5f3ff' },
  sal:           { label: 'SAL',           color: '#f97316', bg: '#fff7ed' },
  chiusura:      { label: 'Chiusura',      color: '#10b981', bg: '#ecfdf5' },
  completato:    { label: 'Completato',    color: '#059669', bg: '#d1fae5' },
}

export const STATO_SAL_CONFIG: Record<string, { label: string; color: string }> = {
  bozza:            { label: 'Bozza',                color: '#9ca3af' },
  in_attesa_dl:     { label: 'Attesa Benestare DL',   color: '#f59e0b' },
  in_attesa_usr:    { label: 'Attesa Erogazione USR', color: '#3b82f6' },
  erogato_parziale: { label: 'Erogato Parziale',      color: '#f97316' },
  erogato_completo: { label: 'Erogato',               color: '#10b981' },
}

export const STATO_PAGAMENTO_CONFIG: Record<string, { label: string; color: string }> = {
  atteso:     { label: 'Atteso',     color: '#6b7280' },
  pagato:     { label: 'Pagato',     color: '#10b981' },
  in_ritardo: { label: 'In Ritardo', color: '#ef4444' },
}

export const TIPOLOGIE_DOCUMENTO_LABEL: Record<string, string> = {
  visura_catastale: 'Visura catastale',
  visura_ipotecaria: 'Visura ipotecaria',
  estratto_mappa: 'Estratto di mappa',
  planimetria_catastale: 'Planimetria catastale',
  planimetria_architettonica: 'Planimetria architettonica',
  proposta_acquisto: 'Proposta di acquisto',
  compromesso: 'Compromesso',
  rogito: 'Rogito',
  ape: 'APE',
  domanda_usr: 'Domanda USR',
  perizia_tecnica: 'Perizia tecnica',
  computo_metrico: 'Computo metrico',
  titolo_edilizio: 'Titolo edilizio',
  contratto_appalto: 'Contratto di appalto',
  polizza_fideiussione: 'Polizza fideiussione',
  durc: 'DURC',
  psc_pos: 'PSC/POS',
  sal_imeco: 'SAL IMECO',
  benestare_dl: 'Benestare DL',
  richiesta_erogazione_usr: 'Richiesta erogazione USR',
  erogazione_usr: 'Erogazione USR',
  certificato_esecuzione: 'Certificato di esecuzione',
  collaudo: 'Collaudo',
  agibilita: 'Agibilità',
  visura_aggiornata: 'Visura aggiornata',
  stato_di_fatto: 'Stato di fatto',
  progetto_architettonico: 'Progetto architettonico',
  progetto_strutturale: 'Progetto strutturale',
  progetto_acustica: 'Progetto acustica',
  relazione_geologica: 'Relazione geologica',
  cme: 'Computo metrico estimativo (CME)',
  qte: 'Quadro tecnico economico (QTE)',
  accollo: 'Accollo',
  scheda_fast: 'Scheda FAST',
  scheda_aedes: 'Scheda AEDES',
  planimetria: 'Planimetria',
  altro: 'Altro',
}

// Bug #11: flag "Progettazione e USR" → voce documentale dedicata mostrata
// nella card omonima di TabAnagrafica (design approvato: docs/superpowers/specs/
// 2026-07-29-flag-progettazione-usr-upload-documento-design.md)
export interface FlagProgettazioneVoce {
  field?: string
  label: string
  tipologia: string
}

export const FLAG_PROGETTAZIONE_USR: FlagProgettazioneVoce[] = [
  { field: 'stato_di_fatto', label: 'Stato di fatto', tipologia: 'stato_di_fatto' },
  { field: 'progetto_architettonico', label: 'Architettonico', tipologia: 'progetto_architettonico' },
  { field: 'progetto_strutturale', label: 'Strutturale', tipologia: 'progetto_strutturale' },
  { field: 'progetto_acustica', label: 'Acustica', tipologia: 'progetto_acustica' },
  { field: 'relazione_geologica', label: 'Relazione geologica', tipologia: 'relazione_geologica' },
  { field: 'cme', label: 'CME', tipologia: 'cme' },
  { field: 'qte', label: 'QTE', tipologia: 'qte' },
  { field: 'accollo', label: 'Accollo', tipologia: 'accollo' },
  { field: 'scheda_fast', label: 'Scheda FAST', tipologia: 'scheda_fast' },
  { field: 'scheda_aedes', label: 'Scheda AEDES', tipologia: 'scheda_aedes' },
  { field: 'planimetria', label: 'Planimetria', tipologia: 'planimetria' },
]

// Feature 4: Workflow documenti
export const STATO_WORKFLOW_CONFIG: Record<string, { label: string; color: string; bg: string }> = {
  bozza:         { label: 'Bozza',         color: '#6b7280', bg: '#f3f4f6' },
  in_revisione:  { label: 'In revisione',  color: '#f59e0b', bg: '#fffbeb' },
  approvato:     { label: 'Approvato',     color: '#10b981', bg: '#ecfdf5' },
  rifiutato:     { label: 'Rifiutato',     color: '#ef4444', bg: '#fef2f2' },
}

// Feature 2: Capital Stack
export const TIPI_FINANZIAMENTO_LABEL: Record<string, string> = {
  debito_bancario: 'Debito bancario',
  mutuo: 'Mutuo',
  equity: 'Equity',
  contributo_usr: 'Contributo USR',
  altro: 'Altro',
}

export const STATO_FINANZIAMENTO_CONFIG: Record<string, { label: string; color: string }> = {
  attivo:     { label: 'Attivo',     color: '#10b981' },
  estinto:    { label: 'Estinto',    color: '#6b7280' },
  in_default: { label: 'In default', color: '#ef4444' },
}

// Feature 3: Pratiche Edilizie
export const TIPI_PRATICA_EDILIZIA_LABEL: Record<string, string> = {
  cila: 'CILA',
  scia: 'SCIA',
  permesso_costruire: 'Permesso di costruire',
  dia: 'DIA',
  agibilita: 'Agibilità',
  collaudo: 'Collaudo',
  altro: 'Altro',
}

export const STATO_PRATICA_CONFIG: Record<string, { label: string; color: string }> = {
  bozza:          { label: 'Bozza',           color: '#6b7280' },
  presentata:     { label: 'Presentata',      color: '#3b82f6' },
  in_istruttoria: { label: 'In istruttoria',  color: '#f59e0b' },
  approvata:      { label: 'Approvata',       color: '#10b981' },
  rigettata:      { label: 'Rigettata',       color: '#ef4444' },
  integrazione:   { label: 'Integrazione',    color: '#f97316' },
}

// Feature 5: Rendicontazioni
export const TIPI_RENDICONTAZIONE_LABEL: Record<string, string> = {
  semestrale: 'Semestrale',
  annuale: 'Annuale',
  finale: 'Finale',
  straordinaria: 'Straordinaria',
}

export const STATO_RENDICONTAZIONE_CONFIG: Record<string, { label: string; color: string }> = {
  bozza:            { label: 'Bozza',            color: '#6b7280' },
  in_approvazione:  { label: 'In approvazione',  color: '#f59e0b' },
  presentata:       { label: 'Presentata',       color: '#3b82f6' },
  approvata:        { label: 'Approvata',        color: '#10b981' },
  integrazione:     { label: 'Integrazione',     color: '#f97316' },
}

// Feature 6: Opportunita
export const FONTI_OPPORTUNITA_LABEL: Record<string, string> = {
  agenzia: 'Agenzia',
  asta: 'Asta',
  privato: 'Privato',
  comune: 'Comune',
  usr: 'USR',
}

export const STATO_OPPORTUNITA_CONFIG: Record<string, { label: string; color: string }> = {
  da_valutare:       { label: 'Da valutare',       color: '#6b7280' },
  in_trattativa:     { label: 'In trattativa',     color: '#f59e0b' },
  offerta_presentata: { label: 'Offerta presentata', color: '#3b82f6' },
  accettata:         { label: 'Accettata',         color: '#10b981' },
  rifiutata:         { label: 'Rifiutata',         color: '#ef4444' },
  acquisita:         { label: 'Acquisita',         color: '#059669' },
}

// Feature 7: Foto Cantiere
export const CATEGORIE_FOTO_LABEL: Record<string, string> = {
  pre_lavori: 'Pre-lavori',
  durante: 'Durante lavori',
  post_lavori: 'Post-lavori',
  collaudo: 'Collaudo',
}

// Feature 8: Valutazioni
export const METODI_VALUTAZIONE_LABEL: Record<string, string> = {
  dcf: 'DCF (Discounted Cash Flow)',
  comparables: 'Comparables',
  cost_replacement: 'Costo di sostituzione',
}

export const FASI_IMMOBILE = [
  'scouting', 'acquisizione', 'pratica_usr', 'appalto', 'sal', 'chiusura', 'completato',
]

export const FASE_COLORI: Record<string, { bg: string; text: string; border: string }> = {
  scouting:      { bg: '#eef2ff', text: '#6366f1', border: '#c7d2fe' },
  acquisizione:  { bg: '#fffbeb', text: '#f59e0b', border: '#fde68a' },
  pratica_usr:   { bg: '#eff6ff', text: '#3b82f6', border: '#bfdbfe' },
  appalto:       { bg: '#f5f3ff', text: '#8b5cf6', border: '#ddd6fe' },
  sal:           { bg: '#fff7ed', text: '#f97316', border: '#fed7aa' },
  chiusura:      { bg: '#ecfdf5', text: '#10b981', border: '#a7f3d0' },
  completato:    { bg: '#d1fae5', text: '#059669', border: '#6ee7b7' },
}

export const VOCE_IMECO_LABEL: Record<string, string> = {
  notifica_preliminare: 'Notifica Preliminare',
  psc: 'PSC',
  utenza_acqua: 'Attivazione Utenza — Acqua',
  utenza_luce: 'Attivazione Utenza — Luce',
  utenza_occupazione_suolo: 'Occupazione Suolo Pubblico',
  cciaa: 'C.C.I.A.A.',
  pos: 'POS',
  antincendio_nomina: 'Antincendio + Nomina',
  pronto_soccorso_nomina: 'Pronto Soccorso + Nomina',
  rls: 'RLS',
  preposto_nomina: 'Preposto + Nomina',
  medico_competente_nomina: 'Nomina Medico Competente',
  rspp: 'RSPP',
  dpi: 'DPI',
  formazione_base: 'Formazione Base',
  carta_identita: "Carta d'Identità",
  idoneita_sanitarie: 'Idoneità Sanitarie',
  unilav: 'UNILAV',
  durc: 'DURC',
  apertura_cantiere_edilconnect: 'Apertura Cantiere Edilconnect',
}

export const VOCE_IMECO_ORDER: string[] = [
  'notifica_preliminare', 'psc', 'utenza_acqua', 'utenza_luce', 'utenza_occupazione_suolo',
  'cciaa', 'pos', 'antincendio_nomina', 'pronto_soccorso_nomina', 'rls',
  'preposto_nomina', 'medico_competente_nomina', 'rspp', 'dpi', 'formazione_base',
  'carta_identita', 'idoneita_sanitarie', 'unilav', 'durc',
]

export const EUR = new Intl.NumberFormat('it-IT', {
  style: 'currency', currency: 'EUR', maximumFractionDigits: 0,
})
